<template>
    <div>
    <v-layout row wrap align-center justify-space-between>
        <v-flex grow class="handbook-leftDivider_hideSmall">
            <v-btn-toggle v-model="inputVal" class="transparent handbook_toggleButton" :mandatory="true" :multiple="multiple">
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'mp'" :color="REPS_COLOUR">
                            <span class="long-button-text chamberButton">
                                {{ alternateText ? "House" : "Member" }}
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ alternateText ? "House" : "Member" }}</span>
                </v-tooltip>
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'senator'" :color="SENATE_COLOUR">
                            <span class="long-button-text chamberButton">
                                {{ alternateText ? "Senate" : "Senator" }}
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ alternateText ? "Senate" : "Senator" }}</span>
                </v-tooltip>
            </v-btn-toggle>
        </v-flex>
    </v-layout>
    </div>
</template>
<script>
export default {
    props: {
        value: {},
        multiple: {
            type: Boolean,
            default: true
        },
        alternateText:  {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inputVal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    data() {
        return {
            REPS_COLOUR: this.$store.state.COLOUR_REPRESENTATIVES,
            SENATE_COLOUR: this.$store.state.COLOUR_SENATE,
        }
    }
}
</script>
<style scoped>
    .chamberButton {
        color: #f5f5f5;
    }
</style>

